import React, { Component } from 'react';
import { Base64 } from 'js-base64';
import Modal from 'react-responsive-modal';
import { Gateway } from '../../BaseUrl';
import { Button } from '../Button';
import { Input } from '../Input';
import { Form } from '../Form';
import { dateSuffix, dateAndMonth, IsEmpty, ToDecmialPlace } from '../../Functions/Generic';
import { Post, Get } from '../../Ajax';
import { LargeRadioButton } from '../GenericComponets/LargeRadioButton';
import { Warning } from '../GenericComponets/Warning';
import { Information } from '../GenericComponets/Information';
import { Danger } from '../GenericComponets/Danger';
import { Select } from '../Select';
import { Success } from '../GenericComponets/Success';
import { PaymentResult } from './PaymentResult';
import { AddCard } from '../AddCard/AddCard';
import { CollectionsNumber } from '../Variables';
import { Left } from 'react-bootstrap/lib/Media';

export class MakePayment extends Component {
    displayName = MakePayment.name

    _isMounted = false;
    constructor(props) {
        super(props);
        this.props.changeLogo("card");

        this.state = {
            loading: false,
            loadingPage: true,
            paymentSent: false,
            hasError: false,
            open: false,
            amount: "",
            paymentResult: {},
            mandateSrc: null,
            cards: [],
            selected: "",
            pleaseSelect: false,
            selectedCard: 0,
            showPaymentWarning: true,
            paymentAmount: 0,
            tempfix: false // DELETE ME WHEN PAYMENTS WORKING AGAIN
        }

        this.amount = React.createRef();
        this.cardSelect = React.createRef();
        this.CallSlimpay = this.CallSlimpay.bind(this);
        this.makePayment = this.makePayment.bind(this);
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.getCards();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    updateState(object, func = () => { }) {
        if (this._isMounted) {
            this.setState(object, func);
        }
    }

    async getCards() {
        try {
            const { isBorrower, summary } = this.props;
            var customerId = isBorrower ? summary.borrowerCustomerId : summary.guarantorCustomerId;
            var role = isBorrower ? "Borrower" : "Guarantor";

            let data = await Get(`${Gateway}/payments/${summary.loanReferenceNumber}/${role}/${customerId}`, "json", () => this.props.Logout(true));

            this.updateState({
                cards: data,
                loadingPage: false
            });
        } catch (e) {
            console.log("error", e);
        }
    }

    async makePayment() {
        const { selected, amount } = this.state;
        const { rmiAmount, totalArrears, currentBalance } = this.props.summary;
        this.updateState({ pleaseSelect: false });

        switch (selected) {
            case "monthly":
                await this.displayMessage(rmiAmount);
                break;
            case "other":
                await this.displayMessage(amount);
                break;
            case "settlement":
                await this.displayMessage(currentBalance);
                break;
            case "arrears":
                await this.displayMessage(totalArrears);
                break;
            default:
                this.updateState({ pleaseSelect: true });
        }
    }

    displayMessage(amount) {
        this.updateState({
            open: true,
            paymentAmount: amount
        });
    }

    async CallSlimpay(amount) {        
        try {
            this.updateState({
                loading: true
            });

            const { isBorrower, personIds, summary, name } = this.props;
            const customer = isBorrower ? "Borrower" : "Guarantor";
            const customerId = isBorrower ? summary.borrowerCustomerId : summary.guarantorCustomerId

            let data = await Post(`${Gateway}/payments/${summary.loanReferenceNumber}/${customer}/${customerId}/CreatePayin`, {
                amount: +amount,
                cardDetailsId: +this.state.selectedCard,
                Event: {
                    AppId: summary.loanReferenceNumber,
                    AgentName: `Customer: ${name.firstname} ${name.lastname}`,
                    PersonId: personIds[0],
                    Role: customer,
                    Source: "Servicing",
                    CustomerId: customerId
                }
            });

            this.updateState({
                paymentResult: data,
                paymentSent: true,
                loading: false,
                hasError: false,
                amount: "",
                open: false
            }, () => this.props.reloadPage());

        } catch (e) {
            console.log("error", e);
            this.updateState({
                loading: false,
                hasError: true,
                amount: "",
                open: false
            });
        }
    };

    setValue(e) {
        var val = e.target.value;
        if (/^(?:\d*\.\d{0,2}|\d+)$/.test(val) || val == "") {
            this.updateState({ amount: val.trim() });
        }
    }

    render() {
        var isEmpty = IsEmpty(this.props.summary);
        const styles = { display: "flex", justifyContent: "space-between" };
        const { amount, selected, loading, open, pleaseSelect, mandateSrc, hasError, paymentAmount = 0 } = this.state;
        const { currentBalance = 0, rmiAmount = 0, nextRmiPaymentDate, totalArrears = 0 } = this.props.summary;
        let arrearsHighlight = selected == "arrears" ? {} : { color: "#de0c0c" };
        const c = CollectionsNumber.replace(/\s/g, '');

        return (
            <div style={{ width: "100%" }}>
                <Modal open={open}
                    onClose={() => this.updateState({ open: false })}
                    center
                    blockScroll={false}
                    classNames={{
                        overlay: styles.customOverlay,
                        modal: "slimpayModal",
                    }} >

                    <h4 style={{ textAlign: "center" }}>Are you sure?</h4>
                    <hr />

                    Are you sure you want to make a payment of <strong> €{parseFloat(paymentAmount).toFixed(2)} </strong>?

                    <div className="form-group" style={{ display: "flex", justifyContent: "space-between", marginTop: "30px" }}>
                        <Button value="No, cancel"
                            skin="default"
                            size="reg"
                            onClick={() => this.updateState({ open: false })} />
                        <Button value="Yes, make payment"
                            skin="primary"
                            size="reg"
                            onClick={() => this.updateState({ open: false }, () => this.CallSlimpay(paymentAmount))} />
                    </div>
                </Modal>
                {/*{this.state.tempfix ?*/}
                    <div className="header">
                        <div className="repaymet-large-details desktop-only">
                            <div className="large-title">
                                <h2 className="text-center"> Make Payment </h2>
                            </div>
                            <div className="container large-details">
                                <div className="large-detail">
                                    <label>Balance To Settle</label>
                                    <p>€{!isEmpty && currentBalance.toFixed(2)}</p>
                                </div>
                                <div className="large-detail">
                                    <label>Payment Amount</label>
                                    <p>€{!isEmpty && rmiAmount.toFixed(2)}</p>
                                </div>
                                <div className="large-detail">
                                    <label>Next Payment Date</label>
                                    <p>{dateAndMonth(nextRmiPaymentDate)}</p>
                                </div>
                            </div>
                        </div>
                        <div className="container repayments-container">
                            <div style={{ maxWidth: "360px", margin: "auto", width: "100%" }}>
                                <h3 className="mobile-only">Make Payment</h3>
                                <div style={styles}>
                                    <label>Current Balance</label>
                                    <p>€{!isEmpty && currentBalance.toFixed(2)}</p>
                                </div>
                                <Form onSubmit={() => this.makePayment()}>
                                    <label>Please select your card</label>
                                    <Select ref={this.cardSelect}
                                        required={true}
                                        defaultOption="- Choose card -"
                                        defaultOptionValue='0'
                                        value={this.state.selectedCard}
                                        onChange={(e) => { this.updateState({ selectedCard: e.target.value }) }}>
                                        {
                                            this.state.cards.map((item, index) => {
                                                return <option style={{ color: "#333" }} key={index} value={item.cardDetailsId}>Card: {item.cardLastFourDigits} - Expiry: {item.expiry}</option>;
                                            })
                                        }
                                    </Select>

                                    <div className="form-group" style={{ marginTop: "-5px", textAlign: "right" }}>
                                        <AddCard {...this.props} isButton={false} text="Add a new card?" onClose={() => this.getCards()} />
                                    </div>

                                    <label>How much would you like to pay?</label>
                                    <div className="radio-group" style={{ margin: "0 0 15px 0", display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                                        {
                                            totalArrears > 0 &&
                                            <LargeRadioButton group="payment-amount" checked={selected == "arrears"}
                                                onClick={() => this.updateState({ selected: "arrears", pleaseSelect: false })} className="payment-label">
                                                <span>
                                                    <h4 style={arrearsHighlight}>€{totalArrears.toFixed(2)}</h4>
                                                    <span style={arrearsHighlight}>Arrears</span>
                                                </span>
                                            </LargeRadioButton>
                                        }

                                        <LargeRadioButton group="payment-amount" checked={selected == "settlement"}
                                            onClick={() => this.updateState({ selected: "settlement", pleaseSelect: false })} className="payment-label">
                                            <span>
                                                <h4>€{ToDecmialPlace(currentBalance)}</h4>
                                                <span>Settlement</span>
                                            </span>
                                        </LargeRadioButton>

                                        <LargeRadioButton group="payment-amount" checked={selected == "monthly"}
                                            onClick={() => this.updateState({ selected: "monthly", pleaseSelect: false })} className="payment-label">
                                            <span>
                                                <h4>€{rmiAmount.toFixed(2)}</h4>
                                                <span>Monthly Installment</span>
                                            </span>
                                        </LargeRadioButton>

                                        <LargeRadioButton group="payment-amount" checked={selected == "other"}
                                            onClick={() => this.updateState({ selected: "other", pleaseSelect: false })} className="payment-label">
                                            <h4>Other</h4>
                                        </LargeRadioButton>
                                    </div>
                                    {
                                        selected == "other" &&
                                        <Input ref={this.amount}
                                            required={true}
                                            placeholder={`Other Amount eg. €${rmiAmount}`}
                                            rules={{
                                                pattern: {
                                                    regex: /^\d+\.?\d*$/,
                                                    message: 'Please enter a valid deimcal number'
                                                },
                                                custom: {
                                                    bool: (amount <= currentBalance),
                                                    message: "You cannot pay more than your current balance to settle"
                                                },
                                                minValue: {
                                                    min: 1
                                                }
                                            }}
                                            value={amount}
                                            onChange={(e) => this.setValue(e)} />
                                    }

                                    {
                                        selected == "monthly" &&
                                        <Information style={{ marginBottom: "5px" }}>
                                            If you are making your payment early and haven't already
                                        spoken with us,  please contact us on <strong><a href="tel:019605983">01 960 5983</a></strong>,
                                            as we may still attempt your payment on
                                            the <strong>{dateAndMonth(nextRmiPaymentDate)}</strong>.
                                        </Information>
                                    }
                                    {
                                        pleaseSelect &&
                                        <Danger>Please choose an amount to pay</Danger>
                                    }
                                    {
                                        (!loading && hasError) &&
                                        <Danger>
                                            Oops! Something went wrong while trying to load your payment
                                            confirmation. Don't worry, your payment hasn't been taken. Please
                                        try again or call <strong><a href="tel:019605983">01 960 5983</a></strong> if
                                            the error persists.
                                        </Danger>
                                    }

                                    <div style={{ margin: "20px 0" }}>
                                        <Button value="Make payment" loading={loading} type="submit" />
                                    </div>

                                    <PaymentResult {...this.state} />
                                </Form>
                                <p className="change-detail-info" >To update or delete your bank or card details, please call us on <a className="change-detail-info" href={"tel:" + c}>{CollectionsNumber}</a></p>
                            </div>
                        </div>
                    </div>                  
            </div>
        );
    }
}

MakePayment.defaultProps = {
    summary: {}
}


// WEBPACK FOOTER //
// ./src/components/MakePayment/MakePayment.js